import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDateRangeInput, MatDateRangePicker } from '@angular/material/datepicker';
import { FieldType } from '@ngx-formly/material/form-field';

@Component({
  selector: 'sc-daterange',
  templateUrl: './daterange.component.html',
  styleUrls: ['./daterange.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DaterangeComponent extends FieldType implements AfterViewInit {
  @ViewChild(MatDateRangeInput, { static: true })
  formFieldControl!: MatDateRangeInput<any>;
  @ViewChild(MatDateRangePicker, { static: true })
  datepickerInput!: MatDateRangePicker<any>;
  @ViewChild('datepickerToggle', { static: true })
  datepickerToggle!: TemplateRef<any>;

  defaultOptions = {
    templateOptions: {
      datepickerOptions: {
        startView: 'year',
        datepickerTogglePosition: 'suffix',
        dateInput: () => {},
        dateChange: () => {},
        monthSelected: () => {},
        yearSelected: () => {}
      }
    }
  };

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.to[this.to.datepickerOptions.datepickerTogglePosition] = this.datepickerToggle;

    // temporary fix for https://github.com/angular/material2/issues/6728
    (this.datepickerInput as any)._formField = this.formField;
  }
}
